'use client'

import { usePathname } from 'next/navigation'

/**
 * The address that produced the 404, printed the way this site prints every
 * other piece of metadata: mono, small, factual.
 *
 * It is worth showing. A visitor who mistyped sees the typo; a visitor who
 * followed a stale link sees what to report. "Er is iets misgegaan" says
 * neither.
 *
 * Client-side because the not-found boundary is not told which path missed —
 * and this is the one thing on the page that has to know.
 */
export function RequestedPath() {
    const path = usePathname()

    if (path === null || path === '/') {
        return null
    }

    return (
        <span className="block truncate font-mono text-[12.5px] text-dim" title={path}>
            {path}
        </span>
    )
}
